import { render, staticRenderFns } from "./PlaybackRateDropdown.vue?vue&type=template&id=15736f35&"
import script from "./PlaybackRateDropdown.vue?vue&type=script&lang=js&"
export * from "./PlaybackRateDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports